import React from "react"
import { ObjectSchema } from "yup"

type SchemaDescription = ReturnType<ObjectSchema<any>["describe"]>

interface IValidationContext {
  schema?: ObjectSchema<any>
  describedSchema?: SchemaDescription
  describeSchema: () => void
}

type TValidationProviderInputProps = "schema"
type TValidationProvider = Pick<IValidationContext, TValidationProviderInputProps> & { children?: React.ReactNode }

export const ValidationContext = React.createContext<IValidationContext>({} as IValidationContext)

export const useValidationContext = () => React.useContext(ValidationContext)

export const ValidationProvider: React.FC<TValidationProvider> = ({ children, schema }) => {
  const [describedSchema, setDescribedSchema] = React.useState<SchemaDescription>()

  const describeSchema = React.useCallback(() => {
    schema && setDescribedSchema(schema.describe())
  }, [schema])

  return (
    <ValidationContext.Provider value={{ schema, describeSchema, describedSchema }}>
      {children}
    </ValidationContext.Provider>
  )
}
